import { Stack } from '@mui/material'
import { getHomeProductNav } from '@/config/navigation/homeProductNav'
import { getSecondarySchema, HOME_PRODUCT_KEYS } from '@/config/navigation/secondaryNav'
import { useSecondaryNavStore } from '@/store/secondaryNavStore'
import SecondaryNavAccountFooter from './components/SecondaryNavAccountFooter'
import SecondaryNavHeaderTitle from './components/SecondaryNavHeaderTitle'
import SecondaryNavShell from './components/SecondaryNavShell'
import { renderSecondaryNavSection } from './renderSecondaryNavSection'
import { useSecondaryNavSectionCtx } from './useSecondaryNavSectionCtx'
import styles from './index.module.scss'

export function SecondaryLeftNavigationView(props) {
  const collapsed = useSecondaryNavStore((state) => state.collapsed)
  const toggleCollapsed = useSecondaryNavStore((state) => state.toggleCollapsed)
  const schema = getSecondarySchema(props.activeKey)
  const homeProductNav =
    props.activeKey === 'home' ? getHomeProductNav(props.homeProduct ?? HOME_PRODUCT_KEYS.CHAT) : null
  const sections = homeProductNav?.sections ?? schema.views[props.activeView ?? schema.initialView] ?? []
  const sectionCtx = useSecondaryNavSectionCtx(props)

  return (
    <SecondaryNavShell
      collapsedForRail={Boolean(props.collapsedForRail)}
      collapsedByUser={collapsed}
    >
      <Stack className={styles.shellColumn} direction="column">
        <Stack className={styles.stack} direction="column">
          <SecondaryNavHeaderTitle
            title={homeProductNav?.headerTitle ?? schema.headerTitle}
            highlighted={homeProductNav?.highlighted ?? schema.highlighted}
            onToggleCollapse={toggleCollapsed}
          />
          {sections.map((section, index) =>
            renderSecondaryNavSection(section, { ...sectionCtx, index }),
          )}
        </Stack>
        <SecondaryNavAccountFooter
          onAccountMenuAction={props.onAccountMenuAction}
          accountFullName={props.accountFullName}
          accountEmail={props.accountEmail}
        />
      </Stack>
    </SecondaryNavShell>
  )
}

export default SecondaryLeftNavigationView
